define('viewmodels/RiskRating/RRPCSConfigure',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, ObjGeneralSettings) {

        var RRSurveyConfigVM = {

            activate: activate,
            attached: attached,
            detached: detached,
            logger: logger,
            appsecurity: appsecurity,
            utils: utils,
            ObjGeneralSettings: ObjGeneralSettings,

            //methods, events, clicks
            RRAreaTabClick: RRAreaTabClick,
            NavigateRR: NavigateRR,
            ClosePopUpMapUsers: ClosePopUpMapUsers,
            GetallSurveys: GetallSurveys,
            GetRRCopyAreas: GetRRCopyAreas,
            AddFactorPopup: AddFactorPopup,
            ConfigureTabclick: ConfigureTabclick,
            MapPRRTabclick: MapPRRTabclick,
            getSurveysforLevel: getSurveysforLevel,
            getRRIDetails: getRRIDetails,
            surveyMapping: surveyMapping,
            SelectAllBusinessUnits: SelectAllBusinessUnits,
            LaunchBusinessunitList: ko.observableArray([]),
            DisableActionButtons: ko.observable(),
            SelectedBuIdList: ko.observableArray([]),
            SelectedUserType: ko.observable(),
            OpenlaunchSurveyPopup: OpenlaunchSurveyPopup,
            AddUserMapping: AddUserMapping,
            SurveyMappingPopup: SurveyMappingPopup,
            RemoveUserMapping: RemoveUserMapping,
            ReplaceUserMapping: ReplaceUserMapping,
            CloseLaunchSurveyPopup: CloseLaunchSurveyPopup,
            MapUsers: MapUsers,
            RRITabClick: RRITabClick,
            NavPillId: ko.observable('RR_REV'), // Survey as default Nav Pill
            NavTabClick: NavTabClick,
            ResponseClick: ResponseClick,
            saveSurveyMapping: saveSurveyMapping,
            selectedQuestion: selectedQuestion,
            assignUsers: assignUsers,
            RoleNameClick: RoleNameClick,
            SelectAllUsers: SelectAllUsers,
            SaveUserMapping: SaveUserMapping,
            SurveyLaunchPopUp: SurveyLaunchPopUp,
            OpenConfigureSurveyPopup: OpenConfigureSurveyPopup,
            onfetchAreas: onfetchAreas,
            SaveSurvey: SaveSurvey,
            AddSurvey: AddSurvey,
            LaunchSurvey: LaunchSurvey,
            UpdateSurvey: UpdateSurvey,
            ExportPRR: ExportPRR,
            ImportPRR: ImportPRR,
            uploadDocumentBtn: uploadDocumentBtn,
            ApplyBlueprintRR: ApplyBlueprintRR,


            //observables
            RRAreaList: ko.observableArray([]),
            SelectedCopyAreas: ko.observable(),
            RREndDate: ko.observable(),
            SurveyTitle: ko.observable(),
            ApplyBlueprintFlag: ko.observable(0),
            MappingList: ko.observable(),
            TabClick: ko.observable(),
            CurrentSurveyId: ko.observable(),
            CurrentRiskFactorId: ko.observable(),
            SurveyCreateModel: ko.observableArray([]),
            editableSurvey: ko.observable(),
            EditFactorVisible: ko.observable(false),
            popUpTitle: ko.observable(),
            addPopUpCssSurvey: ko.observable(),
            CopyAreasList: ko.observableArray([]),
            AssessmentTypeList: ko.observableArray([]),
            SelectedMRRAreaId: ko.observable(),
            SelectedMRRAreaName: ko.observable(),

            RRItemsList: ko.observableArray([]),
            RRItemsTabList: ko.observableArray([]),
            SelectedRRItems: ko.observableArray([]),
            ClickedRRItem: ko.observable(),
            ClickedRAType: ko.observable(),

            ItemQuestionsList: ko.observableArray([]),
            QuestionsListforTable: ko.observableArray([]),

            LevelsList: ko.observableArray([]),
            SelectedLevelId: ko.observable(),
            SelectedLevelName: ko.observable(),
            SelectedAssessmentType: ko.observableArray([]),
            SelectedLevelType: ko.observable(),
            LevelsFlag: ko.observable(),
            SelectedLevelOption: ko.observable(),
            SurveysList: ko.observableArray([]),
            SelectedSurveyTableId: ko.observable(),
            SelectedSurveyName: ko.observable(),
            SelectedSurveyId: ko.observable(),
            IsCurrentSurveyLaunched: ko.observable(),
            WorkFlowList: ko.observableArray([]),
            UsersList: ko.observableArray([]),
            SurveyUsersList: ko.observableArray([]),
            CurrentRoleType: ko.observable(),
            popUpTitleSurvey: ko.observable(),
            //Survey Profiles
            RRSPTabClick: RRSPTabClick,
            RRSurveyProfileList: ko.observableArray([]),
            SelectedSurveyProfileId: ko.observable(),
            SelectedSurveyProfileName: ko.observable(),
            hasChildNodes: ko.observable(false),
            AreaLeveljstree: ko.observableArray([]),
            EditSurvey: EditSurvey,
            DisableApplicabilityDropdown: ko.observable(false),
            CurrentSurveyName: ko.observable(),
            NavigationMenuHideShow: NavigationMenuHideShow,
            CollapseAllTreeView: CollapseAllTreeView,

        };

        return RRSurveyConfigVM;
        var TableObject;

        function activate() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                //code
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
              //  RRSurveyConfigVM.ApplyBlueprintFlag(true);

                if (RRSurveyConfigVM.ObjGeneralSettings === undefined || RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() === undefined || ((RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() !== undefined || RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() !== null) && RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    RRSurveyConfigVM.ObjGeneralSettings.GetLocalizedData().then(function () {
                        RRSurveyConfigVM.SurveyTitle((RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() == undefined || RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() == null || RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList() == undefined || RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList() == null || RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS') == -1) ? 'PCS' : RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList()[RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS')].Name());
                    });
                }
                else
                    RRSurveyConfigVM.SurveyTitle((RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() == undefined || RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList() == null || RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList().length <= 0 || RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList() == undefined || RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList() == null || RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS') == -1) ? 'PCS' : RRSurveyConfigVM.ObjGeneralSettings.LocalizedTextList()[RRSurveyConfigVM.ObjGeneralSettings.LocalizedIndexList.indexOf('PCS')].Name());

                ConfigureTabclick();
               
                //$('#loadingMainImgDiv').show();
                //$('#SurveysDiv').hide();
             //   GetAssessmentTypes();
               
               // GetSurveyProfiles();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }


        function MapUsers(data, event) {
            $('#MapUsersPopUp').modal('show');
            $(".nav-pills a").first().click();
        }


        /********************************** NAV TAB CLICK START *******************************************/

        function NavTabClick(data, event) {

            try {
                if (typeof (event) == "undefined") { // First Load Condition
                    RRSurveyConfigVM.NavPillId("RR_REV");
                    $(".nav-pills a").first().addClass("active");
                }
                else {
                    RRSurveyConfigVM.NavPillId(event.currentTarget.id); // Get the Id of Navbar Pill Selected
                    $('.nav-pills a').removeClass("active");
                    document.getElementById(RRSurveyConfigVM.NavPillId()).classList.add("active");
                    //document.getElementById(RRSurveyConfigVM.NavPillId()).click();
                }


                if (RRSurveyConfigVM.NavPillId() == "RR_REV") {
                    RRSurveyConfigVM.DisableActionButtons(false);
                    RRSurveyConfigVM.popUpTitleSurvey('Assign Reviewers')
                    RRSurveyConfigVM.SelectedBuIdList([])
                    for (var i = 0; i < RRSurveyConfigVM.SurveysList().length; i++) {
                        if (RRSurveyConfigVM.SurveysList()[i].isChecked()) {
                            RRSurveyConfigVM.SelectedBuIdList().push(RRSurveyConfigVM.SurveysList()[i].RRSurveyId());
                        }
                    }

                    RRSurveyConfigVM.SelectedUserType("RR_REV")
                    $('#selectallUsers').prop('checked', false);
                    if (RRSurveyConfigVM.SelectedBuIdList().length == 0) {
                        $('#ValErrorSurveyMapUsers').show();
                        $("#PopupBodyMapUsers").hide();
                        $('#ValErrorSurveyMapUsers').html('No Survey is selected to perform the group actions');
                        RRSurveyConfigVM.DisableActionButtons(true);
                    }
                    else {
                        $('#ValErrorSurveyMapUsers').hide();
                        $("#PopupBodyMapUsers").show();

                        if (!$.fn.DataTable.isDataTable('#MappingTableMapUsers')) {
                            var object = $('#MappingTableMapUsers').DataTable({
                                "pagingType": "full_numbers",
                                "stateSave": true,
                                "paging": true,
                                "lengthMenu": [10, 25, 50, 75, 100]
                            });

                            object.destroy();
                            $("#MappingTableMapUsers tbody tr").remove();
                        }

                        else {
                            var object = $('#MappingTableMapUsers').DataTable({
                                "pagingType": "full_numbers",
                                "stateSave": true,
                                "retrieve": true,
                                "paging": true,
                                "lengthMenu": [10, 25, 50, 75, 100]
                            });

                            object.destroy();
                            $("#MappingTableMapUsers tbody tr").remove();
                        }


                        GetALLRespondents(RRSurveyConfigVM.SelectedUserType()).then(function () {

                        })
                    }
                }

                else if (RRSurveyConfigVM.NavPillId() == "RR_RESP") {
                    //For Responders
                    RRSurveyConfigVM.DisableActionButtons(false);
                    RRSurveyConfigVM.popUpTitleSurvey('Assign Responders')
                    RRSurveyConfigVM.SelectedBuIdList([])
                    for (var i = 0; i < RRSurveyConfigVM.SurveysList().length; i++) {
                        if (RRSurveyConfigVM.SurveysList()[i].isChecked()) {
                            RRSurveyConfigVM.SelectedBuIdList().push(RRSurveyConfigVM.SurveysList()[i].RRSurveyId());
                        }
                    }
                    RRSurveyConfigVM.SelectedUserType("RR_RESP")
                    $('#selectallUsers').prop('checked', false);
                    if (RRSurveyConfigVM.SelectedBuIdList().length == 0) {
                        $('#ValErrorSurveyMapUsers').show();
                        $("#PopupBodyMapUsers").hide();
                        $('#ValErrorSurveyMapUsers').html('No ' + RRSurveyConfigVM.RRSurveyName() + ' is selected to perform the group actions');
                        RRSurveyConfigVM.DisableActionButtons(true);
                    }
                    else {
                        $('#ValErrorSurveyMapUsers').hide();
                        $("#PopupBodyMapUsers").show();
                        var object = $('#MappingTableMapUsers').DataTable();

                        object.destroy();
                        $("#MappingTableMapUsers tbody tr").remove();
                        GetALLRespondents(RRSurveyConfigVM.SelectedUserType()).then(function () {
                        })
                    }
                }
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in CreateSurvey.js';
                logger.logMessage(msg);

            }
        }

        function GetALLRespondents(RoleType) {
            try {
                $('#LoadingImgMapUsers').show();
                $('#MappingTableMapUsers').hide();
                return $.ajax({
                    url: "/api/Survey/GetALLSurveyUsersRR",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, Success) {
                        var MappedList = $.map(jsonResult, function (result) {
                            //if (result.RoleType.indexOf(RoleType) > -1)
                            //    return new L1RespondentListModel(result);
                            if (RoleType == "RR_REV") {
                                if (result.RoleType == RoleType || result.RoleType == "RR_REV" || result.RoleType == "RR_REV2")
                                    return new L1RespondentListModel(result);
                            }
                            else {
                                if (result.RoleType == RoleType)
                                    return new L1RespondentListModel(result);
                            }
                        });
                        RRSurveyConfigVM.SurveyUsersList(MappedList);
                        $('#LoadingImgMapUsers').hide();
                        $('#MappingTableMapUsers').show();
                        $('#MappingTableMapUsers').DataTable();
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetALLRespondents() method in CreateSurvey.js';
                logger.logMessage(msg);
            }
        }
        function AddUserMapping(data, event) {
            try {
                var MappedUserList = generateJsonUsers()
                if (generateJsonUsers().length == 0) {
                    var Object = { BusinessUnitID: RRSurveyConfigVM.SelectedBuIdList()[0], BuSurveyID: RRSurveyConfigVM.ClickedSurveyProfileId(), RoleType: RRSurveyConfigVM.SurveyUsersList()[0].RoleType(), RoleId: RRSurveyConfigVM.SurveyUsersList()[0].RoleId() };
                    var MappedUserList = [];
                    MappedUserList.push(Object)
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingConfiguration/RRAddUsersSurveyAssignment",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(MappedUserList)
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Survey User Mapping has been saved successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                            
                            //$('#MapUsersPopUp').modal('hide');
                            //GetallProfileSurveys();
                        }
                        else {
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {

                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:AddUserMapping() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }

        }
        function L1RespondentListModel(item) {
            try {
                var self = this;
                if (item.UserName.length > 0)
                    self.UserName = ko.observable(item.UserName);
                else
                    self.UserName = ko.observable(item.UserName());
                if (item.Role.length > 0)
                    self.Role = ko.observable(item.Role);
                else
                    self.Role = ko.observable(item.Role());
                if (!isNaN(item.UserId))
                    self.UserId = ko.observable(item.UserId);
                else
                    self.UserId = ko.observable(item.UserId());
                if (item.RoleType.length > 0)
                    self.RoleType = ko.observable(item.RoleType);
                else
                    self.RoleType = ko.observable(item.RoleType());
                if (typeof (item.IsChecked) === "boolean")
                    self.IsChecked = ko.observable(item.IsChecked);
                else
                    self.IsChecked = ko.observable(item.IsChecked());
                if (!isNaN(item.RoleId))
                    self.RoleId = ko.observable(item.RoleId);
                else
                    self.RoleId = ko.observable(item.RoleId());

                self.IsAssigned = ko.observable(item.IsAssigned);
                self.UserRoleName = ko.observable(item.Role);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: L1RespondentListModel() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
    /********************************** NAV TAB CLICK END *******************************************/

        function NavigateRR() {
            router.navigate("#RiskRating/RiskRatingResponsePage", true);
        }

        //#region MRRAreas Methods

        function GetRRAreas() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRRAreas",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RRSurveyConfigVM.RRAreaList(jsonResult);
                                //$('#loadingMainImgDiv').show();
                                //$('#RRAreasTab').tabs();
                                //$('#RRAreasTab').tabs('refresh');
                                //$('#RRAreasTab').tabs({ active: 0 });
                                //$($('#RRAreasTabsUL li').get(0)).trigger('click');
                                //scrollableTabs();
                            }
                            if (jsonResult.length === 0) {
                                //$('#loadingMainImgDiv').hide();
                                //$('#errorAreas').show();
                                //$('#AreaInfoDiv').hide();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Risk Rating Areas. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Risk Rating Areas. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllRRAreas() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function AddFactorPopup() {

        }
        function SelectAllBusinessUnits(data, event) {
            try {
                if (event.currentTarget.checked) {
                    for (var i = 0; i < RRSurveyConfigVM.SurveysList().length; i++) {
                        RRSurveyConfigVM.SurveysList()[i].isChecked(event.currentTarget.checked);
                    }
                }
                else {

                    for (var i = 0; i < RRSurveyConfigVM.SurveysList().length; i++) {
                        RRSurveyConfigVM.SurveysList()[i].isChecked(event.currentTarget.checked);
                    }
                }
                var rows = $("#tblSurveyConfig").dataTable().fnGetNodes();
                $("#tblSurveyConfig").removeClass("border-collpase")
                var cells = [];
                for (var i = 0; i < rows.length; i++) {
                    if (event.currentTarget.checked == true)
                        $(rows[i]).find("td:eq(0)").find('input').prop("checked", true);
                    else
                        $(rows[i]).find("td:eq(0)").find('input').prop("checked", false);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllBusinessUnits() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function OpenlaunchSurveyPopup() {
            try {

                $("#frmlaunchPopup").modal('show');
                RRSurveyConfigVM.SelectedBuIdList([]);
                RRSurveyConfigVM.DisableActionButtons(false);
                RRSurveyConfigVM.popUpTitle('Launch Survey')
                var arr = [];

                for (var i = 0; i < RRSurveyConfigVM.SurveysList().length; i++) {
                    if (RRSurveyConfigVM.SurveysList()[i].isChecked()) {
                        RRSurveyConfigVM.SelectedBuIdList().push(RRSurveyConfigVM.SurveysList()[i].RRSurveyId());
                       
                    }
                    else {
                        arr.push(RRSurveyConfigVM.SurveysList()[i].RRSurveyId())
                    }
                }


                if (RRSurveyConfigVM.SelectedBuIdList().length == 0) {
                    $('#ValErrorLaunch').show();
                    $("#LaunchPopupBody").hide();
                    $('#ValErrorLaunch').html('No ' + RRSurveyConfigVM.RRSurveyName() + ' is selected to perform the group actions');
                    RRSurveyConfigVM.DisableActionButtons(true);
                }
                else {
                    $('#ValErrorLaunch').hide();
                    $("#LaunchPopupBody").show();
                    RRSurveyConfigVM.LaunchBusinessunitList([])
                    if (TableObject != undefined) {

                        TableObject.destroy();
                        $("#SurveyLaunchTable tbody tr").remove();
                    }
                    else {
                        TableObject = $("#SurveyLaunchTable").DataTable();
                        $("#SurveyLaunchTable").removeClass("border-collpase")
                        $("#SurveyLaunchTable tbody tr").remove();
                        TableObject.destroy();
                    }
                    var mapB = $.map(RRSurveyConfigVM.SurveysList(), function (item) {

                        return new LaunchBusinessUnitModel(item);
                    })

                    RRSurveyConfigVM.LaunchBusinessunitList(mapB);
                    for (var i = 0; i < arr.length; i++) {
                        RRSurveyConfigVM.LaunchBusinessunitList.remove(function (item) { return item.RRSurveyId == arr[i] })
                    }
                    TableObject = $("#SurveyLaunchTable").DataTable();
                    $("#SurveyLaunchTable").removeClass("border-collpase")

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in OpenlaunchSurveyPopup() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function ClosePopUpMapUsers() {
            GetRRSurveys().then(function () {
                GetUsersListForAllSurveys();
            });
        }

        function CloseLaunchSurveyPopup() {
            try {
                $("#frmlaunchPopup").modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in CloseLaunchSurveyPopup() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        


        function RemoveUserMapping(data, event) {
            try {
                var MappedUserList = generateJsonUsers()
                if (generateJsonUsers().length == 0) {
                    var Object = { BusinessUnitID: RRSurveyConfigVM.SelectedBuIdList()[0], BuSurveyID: RRSurveyConfigVM.ClickedSurveyProfileId(), RoleType: RRSurveyConfigVM.SurveyUsersList()[0].RoleType(), RoleId: RRSurveyConfigVM.SurveyUsersList()[0].RoleId() };
                    var MappedUserList = [];
                    MappedUserList.push(Object)
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingConfiguration/RRRemoveUsersSurveyAssignment",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(MappedUserList)
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Survey User Mapping has been saved successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                           
                            //$('#MapUsersPopUp').modal('hide');
                            //GetallProfileSurveys();
                        }
                        else {
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {

                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:RemoveUserMapping() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }

        }

        function ReplaceUserMapping(data, event) {
            try {
                SaveMappingPopUp();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:SaveUserMapping() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SaveMappingPopUp() {
            try {
                var MappedUserList = generateJsonReplaceUsers()
                if (generateJsonUsers().length == 0) {
                    var Object = { BusinessUnitID: RRSurveyConfigVM.SelectedBuIdList()[0], BuSurveyID: RRSurveyConfigVM.CurrentRiskFactorId(), RoleType: RRSurveyConfigVM.SurveyUsersList()[0].RoleType(), RoleId: RRSurveyConfigVM.SurveyUsersList()[0].RoleId() };
                    var MappedUserList = [];
                    MappedUserList.push(Object)
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/SetSurveyUserMapping",
                    headers: headers,
                    type: "POST",
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(MappedUserList)
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Survey User Mapping has been saved successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                           // $('#SurveyAssignment').modal('hide');
                            //$('#MapUsersPopUp').modal('hide');
                           
                        }
                        else {
                            logger.logError('An error has occurred while saving User Mapping. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (jsonResult, error) {

                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:SaveMappingPopUp() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function onfetchAreas(data) {
            GetRRCopyAreas();
        }

        function generateJsonUsers() {
            try {
                var MainList = [];
                for (var i = 0; i < RRSurveyConfigVM.SelectedBuIdList().length; i++) {
                    var mappedlist = $.map(RRSurveyConfigVM.SurveyUsersList(), function (item) {
                        if (item.IsChecked())
                            return { BusinessUnitID: RRSurveyConfigVM.SelectedBuIdList()[i], BuSurveyID: RRSurveyConfigVM.CurrentRiskFactorId(), RoleID: item.RoleId(), RoleType: item.RoleType(), Username: item.UserName(), UserId: item.UserId() };
                    });
                    var x = "temp";
                    for (var j = 0; j < mappedlist.length; j++) {
                        MainList.push(mappedlist[j]);
                    }
                }


                return MainList

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:generateJsonUsers() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function generateJsonReplaceUsers() {
            try {
                var MainList = [];
                for (var i = 0; i < RRSurveyConfigVM.SelectedBuIdList().length; i++) {
                    var mappedlist = $.map(RRSurveyConfigVM.SurveyUsersList(), function (item) {
                        if (item.IsChecked())
                            return { SurveyId: RRSurveyConfigVM.SelectedBuIdList()[i], SurveyProfileId: RRSurveyConfigVM.CurrentRiskFactorId(), RoleID: item.RoleId(), RoleType: item.RoleType(), Username: item.UserName(), UserId: item.UserId(), IsAssigned : true};
                    });
                    var x = "temp";
                    for (var j = 0; j < mappedlist.length; j++) {
                        MainList.push(mappedlist[j]);
                    }
                }


                return MainList

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:generateJsonUsers() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function GetRRCopyAreas() {
            try {
                var RATIDs = "";
                for (var i = 0; i < RRSurveyConfigVM.SelectedAssessmentType().length; i++) {
                    if (RATIDs === "")
                        RATIDs += RRSurveyConfigVM.SelectedAssessmentType()[i];
                    else
                        RATIDs += "," + RRSurveyConfigVM.SelectedAssessmentType()[i];
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRRCopyOverAreas",
                    type: "GET",
                    headers: headers,
                    data: { "SelectedRAT": RATIDs }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                //var mappedareas = $.map(jsonResult, function (item) {
                                //        return new RRAreaModel(item);                                   
                                //});
                                RRSurveyConfigVM.CopyAreasList([]);
                                var sel = [];
                                for (var i = 0; i < jsonResult.length; i++) {
                                    RRSurveyConfigVM.CopyAreasList.push(new RRAreaModel(jsonResult[i]));
                                }
                                //jsonResult.foreach(function (item) {
                                //    RRSurveyConfigVM.CopyAreasList.push(item);
                                //});
                               // RRSurveyConfigVM.CopyAreasList(sel);

                                $('#copyareasMultiselect').multiselect();
                                $('#copyareasMultiselect').multiselect('refresh');
                            }
                            else if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                                $('#errorAreas').show();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRAreas() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }
        function GetAssessmentTypes() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAssessmentTypes",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                var mappedAssessmentList = $.map(jsonResult, function (result) {
                                    return new AssessmentListModel(result);
                                });

                                RRSurveyConfigVM.AssessmentTypeList(mappedAssessmentList);
                                //$('#RAApplicability').multiselect();
                                //$('#RAApplicability').multiselect('refresh');
                                $('#loadingMainImgDiv').hide();
                               
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                                $('#errorAreas').show();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while deleting the assessment type. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAssessmentTypes() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }

        function NavigationMenuHideShow(data) {
            try {
                if (data == "Hide") {
                    // Hides Area NavigationMenu
                    $('#HideNavMenu').hide();
                    $('#ShowNavMenu').show();
                    $('#FilterAreaAccordion').hide();
                    $("#bottomDivAreaType").removeClass("col-lg-9").addClass("col-lg-12");
                   // $(".rabrd").addClass("raBreadcrumb");

                }
                else {
                    // Shows Area NavigationMenu
                    $('#HideNavMenu').show();
                    $('#ShowNavMenu').hide();
                    $('#FilterAreaAccordion').show();
                    $("#bottomDivAreaType").removeClass("col-lg-12").addClass("col-lg-9");
                   // $(".rabrd").removeClass("raBreadcrumb");
                }

                //if (AMLQsViewModel.ClickedRiskAreaType() === 'QUAL')
                //    RestructureQualitative();
                //else
                //    RestructureQuan();

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        }
        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == "Expand") {
                $('#jsTreeAreaLevel').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text("Collapse");
                $("#arrowSpan").removeClass("fa-caret-right").addClass("fa-caret-down");
            }
            else {
                $('#jsTreeAreaLevel').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text("Expand");
                $("#arrowSpan").removeClass("fa-caret-down").addClass("fa-caret-right");

            }
        }
        
        function RRAreaTabClick(data, event) {
            try {
                $('#loadingMainImgDiv').show();
                $('#SurveysDiv').hide();
                $('#errorDropdown').hide();
                RRSurveyConfigVM.SelectedMRRAreaId(data.MRRAId);
                RRSurveyConfigVM.SelectedMRRAreaName(data.MRRAName);
                RRSurveyConfigVM.AssessmentTypeList(data.RATArray);

                $('#lblRRAName').empty();
                document.getElementById('lblRRAName').innerHTML = data.MRRAName;
                $('#lblApplicability').empty();
                document.getElementById('lblApplicability').innerHTML = data.ApplicableRATNames;
                GetRRSurveyLevels().then(function () {
                    GetRRItems();
                    GetUsersListForAllSurveys();
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRAreaTabClick() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region SurveyProfiles

        function GetSurveyProfiles() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetSurveyProfiles",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RRSurveyConfigVM.RRSurveyProfileList(jsonResult);
                                $('#loadingMainImgDiv').show();
                                $('#RRAreasTab').tabs();
                                $('#RRAreasTab').tabs('refresh');
                                $('#RRAreasTab').tabs({ active: 0 });
                                $($('#RRAreasTabsUL li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                            if (jsonResult.length === 0) {
                                $('#loadingMainImgDiv').hide();
                                $('#errorAreas').show();
                                $('#AreaInfoDiv').hide();
                            }
                        }

                        else {
                            $('#loadingMainImgDiv').hide();
                            logger.logError('Some error occured while fetching the Risk Rating Survey Profiles. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Risk Rating Survey Profiles. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyProfiles() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function ConfigureTabclick(data, event) {
           
            //RRSurveyConfigVM.TabClick("1");
            //RRSurveyConfigVM.AreaLeveljstree();
            //RRSurveyConfigVM.hasChildNodes();
            ////$('#TreeStructureMapPRR').hide();
            ////$('#TreeStructureConfigurePRR').show();
            //$('#FilterAreaAccordionMap').hide();
            //$('#MapRRButtons').hide();
            //$('#configuresurvey').show();
            //$('#FilterAreaAccordion').show();
            //$('#ConfigureProfileTab').show();
            //$('#MapPRRTab').hide();
            //$('#SurveysDiv').show();
            //$('#MapPRRDiv').hide();
            InitiateLevelTree(data);
    
        }
        function MapPRRTabclick(data, event) {
            $('#1').removeClass('active');
            $('#2').addClass('active');
            $('#MapPRRDiv').show();
            RRSurveyConfigVM.TabClick("2");     
            RRSurveyConfigVM.AreaLeveljstree();
            $('#FilterAreaAccordionMap').show();
            $('#MapRRButtons').show();
            $('#configuresurvey').hide();
            $('#FilterAreaAccordion').hide();
            $('#SurveysDiv').hide();
            RRSurveyConfigVM.hasChildNodes();
            //$('#TreeStructureMapPRR').show();
            //$('#TreeStructureConfigurePRR').hide();
           
            $('#MapPRRTab').show();
           
           
            InitiateLevelTree();            
        }

        function RRSPTabClick(data, event) {
            try {
                $('#loadingMainImgDiv').show();
                $('#SurveysDiv').hide();
                $('#errorDropdown').hide();
                RRSurveyConfigVM.SelectedMRRAreaId(data.MRRAId);
                RRSurveyConfigVM.SelectedMRRAreaName(data.MRRAName);
                RRSurveyConfigVM.AssessmentTypeList(data.RATArray);
                RRSurveyConfigVM.SelectedSurveyProfileId(data.SPId);
                RRSurveyConfigVM.SelectedSurveyProfileName(data.SPName);
                $('#lblRRAName').empty();
                document.getElementById('lblRRAName').innerHTML = data.MRRAName;
                $('#lRRSurveyConfigVMblApplicability').empty();
                document.getElementById('lblApplicability').innerHTML = data.ApplicableRATNames;
                GetRRSurveyLevels().then(function () {
                    GetRRItems();
                   GetUsersListForAllSurveys();
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRSPTabClick() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        function ResponseClick() {
            try {
                router.navigate("#RiskRating/RiskRatingResponsePage", true);
            }
            catch (e){

}
        }

        //#region SurveyLevels Methods
        function OpenConfigureSurveyPopup(data) {
            try {
                RRSurveyConfigVM.EditFactorVisible(false);
                RRSurveyConfigVM.SelectedAssessmentType([]);
                RRSurveyConfigVM.SelectedCopyAreas([]);
                RRSurveyConfigVM.CopyAreasList([]);
                RRSurveyConfigVM.AssessmentTypeList([]);
             
                var newAssessment = new SurveyListModel({ RRSurveyId: 999, RRSurveyName: "", RRSurveySecondaryName: "", RRFactorsNames: "", RRSurveyApplicableNames: "", RREndDate:"" });
                
                RRSurveyConfigVM.SurveyCreateModel(newAssessment);
                RRSurveyConfigVM.editableSurvey(newAssessment);
                GetAssessmentTypes();
                $("#RREndDate").datepicker();
              RRSurveyConfigVM.popUpTitle("Add new survey component");
                var windowweight = $(window).height() / 1.8;
                var windowHeight = $(window).innerWidth() - 144;
                RRSurveyConfigVM.addPopUpCssSurvey(true);
                $('#LoadingImgAddSrPopup').hide();
                $('#frmSurveyPopup').modal('show');
                $('#modalContent').css({
                    'margin-top': 'auto'
                });
                GetallSurveys().then(function () {
                    $('#copyareasMultiselect').multiselect();
                    $('#DivForScroll').show();
                    $('#LoadingImgAddSrPopup').show();
                })

                //GetallSurveys().then(function () {
                //    $('#SurveyAssessmentApplicability').multiselect();
                //    $('#SurveyAssessmentApplicability').multiselect('refresh');
                //    $('#LoadingImgAddSrPopup').hide();
                //    $('#DivForScroll').show();

                //})

                
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OpenConfigureSurveyPopup() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SurveyListModel(item) {
            try {
                var self = this;
                self.RRSurveyId = ko.observable($('<div/>').html(item.RRSurveyId).text());
                self.RRSurveyName = ko.observable(item.RRSurveyName);
                self.RRSurveySecondaryName = ko.observable($('<div/>').html(item.RRSurveySecondaryName).text());
                self.RRFactors = ko.observable($('<div/>').html(item.RRFactors).text());
                self.RRFactorsNames = ko.observable($('<div/>').html(item.RRFactorsNames).text());
                self.RRApplicability = ko.observable($('<div/>').html(item.RRSurveyApplicableIDs).text());
                self.RRApplicabilityNames = ko.observable($('<div/>').html(item.RRSurveyApplicableNames).text());
                self.RRBlueprintApplied = ko.observable($('<div/>').html(item.IsBlueprintApplied).text());
                self.RREndDate = ko.observable(item.RREndDate);
                // self.RRFactorNames = ko.observable($('<div/>').html(item.RRFactorsNames).text());
                
                self.Editing = false;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyListModel() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function GetRRSurveyLevels() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRSurveyLevels?SelectedMRRAId=" + RRSurveyConfigVM.SelectedMRRAreaId() + "&SelectedSurveyProfileId=" + RRSurveyConfigVM.SelectedSurveyProfileId(),
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        $('#loadingMainImgDiv').hide();
                        if (jsonResult.Flag === 1) {
                            RRSurveyConfigVM.LevelsList(jsonResult.LevelsList);
                            RRSurveyConfigVM.SelectedLevelId(jsonResult.LaunchedLevelId);
                            RRSurveyConfigVM.SelectedLevelName(jsonResult.LaunchedLevelName);
                            RRSurveyConfigVM.LevelsFlag(jsonResult.IsActiveFlag);
                            RRSurveyConfigVM.SelectedLevelType(jsonResult.LaunchedLevelId.split('_')[0]);
                            if (RRSurveyConfigVM.SelectedLevelId() !== undefined) {
                                RRSurveyConfigVM.SelectedLevelOption(jsonResult.LaunchedLevelId);
                                GetRRSurveys();
                            }
                        }
                        else {
                            logger.logError('Some error occured while fetching the Survey Levels. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Survey Levels. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRSurveyLevels() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function getSurveysforLevel(data, event) {
            try {
                if ($("#LaunchLevelDropDown option:selected").text() === "Select...") {
                    $('#errorDropdown').show();
                    $('#SurveysDiv').hide();
                }
                else {
                    RRSurveyConfigVM.SelectedLevelType(RRSurveyConfigVM.SelectedLevelOption()[0].split('_')[0]);
                    $('#errorDropdown').hide();
                    GetRRSurveys();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getSurveysforLevel() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region RRItems-Questions-Mapping

        function GetRRItems() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/GetRRItems?SelectedMRRAreaId=" + RRSurveyConfigVM.SelectedMRRAreaId() + "&SelectedSurveyProfileId=" + RRSurveyConfigVM.SelectedSurveyProfileId(),
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        $('#loadingMainImgDiv').hide();
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RRSurveyConfigVM.RRItemsList(jsonResult);
                            }
                            else {
                                logger.logError('An error has occured while fetching the Risk Rating Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                        }
                        else {
                            logger.logError('An error has occured while fetching the Risk Rating Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Risk Rating Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRItems() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function getRRIDetails(data, events) {
            try {
                $('#valErrorMapping').hide();
                $('#NoRRISelected').hide();
                $('#saveMappingBtn').show();
                if (RRSurveyConfigVM.SelectedRRItems().length === 0) {
                    $('#NoRRISelected').show();
                    $('#RRITabsDiv').hide();
                    $('#QuestionsDiv').hide();
                    $('#saveMappingBtn').hide();
                    // $('#selectAllDiv').hide();
                    return;
                }
                var RRIArray = [];
                var RRIString = "";
                for (var i = 0; i < RRSurveyConfigVM.RRItemsList().length; i++) {
                    for (var j = 0; j < RRSurveyConfigVM.SelectedRRItems().length; j++) {
                        if (RRSurveyConfigVM.SelectedRRItems()[j] === RRSurveyConfigVM.RRItemsList()[i].RRItemId) {
                            RRIArray.push(RRSurveyConfigVM.RRItemsList()[i]);
                            if (RRIString === "")
                                RRIString += RRSurveyConfigVM.SelectedRRItems()[j];
                            else
                                RRIString += "," + RRSurveyConfigVM.SelectedRRItems()[j];
                        }
                    }
                }
                RRSurveyConfigVM.RRItemsTabList(RRIArray);
                GetRRIQuestionDetails(RRIString).then(function () {
                    $('#RRITabsDiv').show();
                    $('#QuestionsDiv').hide();

                    $('#RRITabsDiv').tabs();
                    $('#RRITabsDiv').tabs('refresh');
                    $('#RRITabsDiv').tabs({ active: 0 });
                    $($('#RRITabsUL li').get(0)).trigger('click');
                    scrollableTabs();
                });

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: getRRIDetails() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function GetRRIQuestionDetails(RRIString) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRIQuestionDetails",
                    type: "GET",
                    headers: headers,
                    data: { "SelectedMRRAId": parseInt(RRSurveyConfigVM.SelectedMRRAreaId()), "RRItemIds": RRIString }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {

                                var mappedIQList = $.map(jsonResult, function (result) {
                                    return new RRItemQuestionsModel(result);
                                });
                                RRSurveyConfigVM.ItemQuestionsList(mappedIQList);

                            }
                            else {
                                logger.logError('Can not fetch the Question Details. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                        }
                        else {
                            logger.logError('Some error has occurred while fetching the Question Details.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Question Details. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRIQuestionDetails() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function RRITabClick(data, event) {
            try {
                $('#QuestionsDiv').show();
                // $('#selectAllDiv').show();
                $('#loadingQImgDiv').hide();
                RRSurveyConfigVM.ClickedRRItem(data.RRItemId);
                createQuestionsTable(data.RRItemId);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRITabClick() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function createQuestionsTable(RRItemId) {
            try {
                for (var i = 0; i < RRSurveyConfigVM.ItemQuestionsList().length; i++) {
                    if (RRItemId === RRSurveyConfigVM.ItemQuestionsList()[i].RRItemId()) {
                        var QArray = $.map(RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList(), function (result) {
                            return new RRQuestionsModel({
                                RRItemId_Ques: result.RRItemId_Ques(),
                                QuestionId: result.QuestionId(),
                                QuestionName: result.QuestionName(),
                                UniqueItemQuesId: result.UniqueItemQuesId(),
                                IsChecked: result.IsChecked()
                            });
                        });
                    }
                }
                RRSurveyConfigVM.QuestionsListforTable([]);

                tableObj = $('#tblQuestions').DataTable();
                tableObj.destroy();
                $('#tblQuestions tbody tr').remove();

                RRSurveyConfigVM.QuestionsListforTable(QArray);

                $('#tblQuestions').DataTable({
                    "order": [],
                    "aaSorting": [],
                    "bResponsive": true,
                    "aoColumnDefs": [
                        {
                            "aTargets": [0],
                            "bSortable": false
                        }, {
                            "aTargets": [1],
                            "bSearchable": false
                        }
                    ]
                });
                $('#tblQuestions').DataTable().draw(false);

                var count = 0;
                for (var i = 0; i < RRSurveyConfigVM.QuestionsListforTable().length; i++) {
                    if (RRSurveyConfigVM.QuestionsListforTable()[i].IsChecked() === true) {
                        count++;
                    }
                }
                if (count === RRSurveyConfigVM.QuestionsListforTable().length)
                    document.getElementById(RRSurveyConfigVM.ClickedRRItem() + "_selectAllInner").checked = true;
                else
                    document.getElementById(RRSurveyConfigVM.ClickedRRItem() + "_selectAllInner").checked = false;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: createQuestionsTable() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function selectedQuestion(data, event) {
            try {
                rowId = event.currentTarget.id;
                ItemId = rowId.split('_');
                for (var i = 0; i < RRSurveyConfigVM.ItemQuestionsList().length; i++) {
                    for (var j = 0; j < RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList().length; j++) {

                        if (RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].UniqueItemQuesId() === rowId) {
                            RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].IsChecked(event.currentTarget.checked);
                            if (event.currentTarget.checked === false) {
                                document.getElementById(RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].RRItemId_Ques() + "_selectAllInner").checked = false;
                                //document.getElementById("selectAllOuter").checked = false;
                            }
                        }

                        else if (RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].RRItemId_Ques() === parseInt(ItemId[0]) && ItemId[1] === "selectAllInner") {
                            RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].IsChecked(event.currentTarget.checked);
                            if (event.currentTarget.checked === true) {
                                document.getElementById(RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].UniqueItemQuesId()).checked = true;
                            }
                            else if (event.currentTarget.checked === false) {
                                document.getElementById(RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].UniqueItemQuesId()).checked = false;

                            }
                        }
                        //else if (rowId === "selectAllOuter") {
                        //    RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].IsChecked(event.currentTarget.checked);
                        //    if (event.currentTarget.checked === true) {
                        //        document.getElementById(RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].UniqueItemQuesId()).checked = true;
                        //    }
                        //    else if (event.currentTarget.checked === false) {
                        //        document.getElementById(RRSurveyConfigVM.ItemQuestionsList()[i].QuestionsList()[j].UniqueItemQuesId()).checked = false;
                        //    }
                        //}
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: selectedQuestion() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function GetMappedSurveyQuestions() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetMappedSurveyQuestions",
                    type: "GET",
                    headers: headers,
                    data: { "SelectedMRRAId": parseInt(RRSurveyConfigVM.SelectedMRRAreaId()), "SelectedSurveyId": RRSurveyConfigVM.SelectedSurveyId() }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {

                                var mappedIQList = $.map(jsonResult, function (result) {
                                    return new RRItemQuestionsModel(result);
                                });
                                RRSurveyConfigVM.ItemQuestionsList(mappedIQList);

                            }
                            else {
                                logger.logError('Can not fetch the Mapped Question Details. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                        }
                        else {
                            logger.logError('Some error has occurred while fetching the Mapped Question Details.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Question Details. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetMappedSurveyQuestions() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region RRSurveys Methods

        function GetRRSurveys() {
            try {
                
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
               return $.ajax({
                    url: "/api/RiskRatingDashboard/GetAllRRSurveys",
                    type: "GET",
                    headers: headers,
                    data: {
                        "SelectedSurveyId" : RRSurveyConfigVM.CurrentSurveyId()
                    }
                })
                    .success(function (jsonResult, error) {
                        try {
                            $('#loadingMainImgDiv').hide();
                           
                            if (jsonResult !== null && jsonResult.length > 0) {

                                $('#SurveysDiv').show();

                                tableObj = $('#tblSurveyConfig').DataTable();
                                tableObj.destroy();
                                $('#tblSurveyConfig tbody tr').remove();

                                var mappedList = $.map(jsonResult, function (result) {
                                    return new RRSurveyModel(result);
                                });

                                RRSurveyConfigVM.SurveysList(mappedList);

                                $('#tblSurveyConfig').DataTable({
                                    "order": [],
                                    "aaSorting": [],
                                    "bResponsive": true,
                                    "stateSave": true,
                                    "searching": true,
                                    "bPaginate": true,
                                    "aoColumnDefs": [
                                        {
                                            "aTargets": [0],
                                            "bSortable": false
                                        },
                                        {
                                            "aTargets": [1],
                                            "bSortable": false
                                        },
                                        {
                                            "aTargets": [2],
                                            "bSortable": false
                                        },
                                        {
                                            "aTargets": [3],
                                            "bSortable": false
                                        },
                                        {
                                            "aTargets": [4],
                                            "bSortable": false
                                        },
                                        
                                    ],
                                    "destroy": true
                                });
                                $('#tblSurveyConfig').DataTable().draw(false);

                            }
                            else if (jsonResult.length == 0) {
                                //RRSurveyConfigVM.SurveysList([]);
                                if ($.fn.DataTable.isDataTable('#tblSurveyConfig')) {
                                    var tableObj = $('#tblSurveyConfig').DataTable();
                                    tableObj.destroy();
                                    $('#tblSurveyConfig tbody tr').remove();
                                }
                                //var Surveytableobject = $('#tblSurveyConfig').DataTable();
                                //if (Surveytableobject != null) {
                                //   // $('#tblSurveyConfig').empty();
                                //}
                                //$('#tblSurveyConfig tbody tr').remove();
                                if (!$.fn.DataTable.isDataTable('#tblSurveyConfig')) {
                                    $('#tblSurveyConfig').DataTable({
                                        
                                        "bResponsive": true,
                                        "stateSave": true,
                                        "searching": true,
                                        "bPaginate": true, 
                                        "order": [],
                                        "orderable": false
                                        
                                    });
                                }
                               
                                }
                               
                            else {
                                logger.logError('Some error occured while fetching the Surveys. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRRSurveys() method in RRConfigureSurvey.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Surveys. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRSurveys() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function ExportPRR() {
            try {
                var payLoad = {};
                
                payLoad = {
                    t: appsecurity.getAuthenticationInfo(), SurveyProfileID: RRSurveyConfigVM.CurrentRiskFactorId(), SurveyProfileName: RRSurveyConfigVM.CurrentSurveyName()
                };
                utils.postAndRedirect(rootPath + "/FileDownload/MapPRRSurvey", payLoad, '_blank');

                GetRRSurveys().then(function () {
                    GetUsersListForAllSurveys();
                })
               
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in ExportPRR() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }
        }
       
        function ImportPRR(data, event) {
            try {
                $('#uploadDownloadPopup').modal('show');
                document.getElementById('valfactorerror').innerHTML = "";
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: uploadDownloadTemplate() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function uploadDocumentBtn() {
            try {
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    //if (RRSurveyConfigVM.CurrentSurveyName() != FileName) {
                    //    document.getElementById('valfactorerror').innerHTML = "Incorrect file upload";
                    //    $('#valfactorerror').show();
                    //}

                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX' || FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM') {
                        if (FileList[0].size <= 1073741824) {
                            document.getElementById('valfactorerror').innerHTML = "";
                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function () {
                                if (request.readyState == 1) {
                                    document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                    $('#valfactorerror').show();
                                }
                                else if (request.readyState == 4) {
                                    if (request.status == 200) {
                                        if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                            document.getElementById('FileUploader').value = null;
                                            if (request.responseText == "2" || request.responseText == "-1") {
                                                document.getElementById('valfactorerror').innerHTML = "Error in file upload!";
                                                logger.logWarning('Excel format mismatch! Please check and try again.', 'Warning', system.getModuleId(RRSurveyConfigVM), true);
                                                $('#valfactorerror').show();
                                            }
                                            else {
                                                document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                                logger.logSuccess('Matrix uploaded successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                                                //   $('#valfactorerror').show();
                                              
                                            }
                                        }
                                        else {
                                            document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                            logger.logError('Some error occured while uploading report.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                                            $('#valfactorerror').show();
                                            document.getElementById('FileUploader').value = null;
                                        }
                                    }
                                    else
                                        ajaxFail(request, "");
                                }
                            };
                            request.upload.addEventListener('progress', function (event) {
                                document.getElementById('valfactorerror').innerHTML = "Uploading File...";
                            });
                            request.withCredentials = true;
                            
                            //var apiString = "/api/Survey/UploadExcelTemplatePCS?SurveyProfileID="+ RRSurveyConfigVM.CurrentRiskFactorId();
                            request.open('POST',"/api/Survey/UploadExcelTemplatePCS?SurveyProfileID=" + RRSurveyConfigVM.CurrentRiskFactorId());
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);

                        }
                        else {
                            document.getElementById('FileUploader').value = null;
                            logger.logError("Upload File Size cannot exceed " + (SrViewModel.UploadFileSize() / 1048576) + " MB. Please try uploading a file of lesser size.", 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    }
                    else {
                        document.getElementById('FileUploader').value = null;
                        logger.logError('Please select valid file to upload.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    }
                }
                else {
                    document.getElementById('FileUploader').value = null;
                    logger.logError('Please select a file to upload.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                }
                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then()
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in Blueprint.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in Blueprint.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in Blueprint.js';
                logger.logMessage(msg);
            }
        }

        function GetMappingList() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingConfiguration/GetFactorsMappingRR",
                    type: "GET",
                    headers: headers,
                    data: { "FactorID": RRSurveyConfigVM.CurrentRiskFactorId(), "ProfileID": RRSurveyConfigVM.CurrentSurveyId() }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null && jsonResult.length > 0) {
                            var Surveytableobject = $('#tblFactorMap').DataTable();
                            Surveytableobject.destroy();
                            $('#tblFactorMap tbody tr').remove();
                            RRSurveyConfigVM.MappingList(jsonResult);
                            $('#tblFactorMap').DataTable({
                                "bResponsive": true,
                                "stateSave": true,
                                "paging": true,
                                "order": [],
                                "orderable": false
                            })
                        }
                        
                        else if (jsonResult != null && jsonResult.length == 0) {
                            var Surveytableobject = $('#tblFactorMap').DataTable();
                            Surveytableobject.destroy();
                            $('#tblFactorMap tbody tr').remove();
                            $('#tblFactorMap').DataTable({
                                "stateSave": true,
                                "targets": 'no-sort',
                                "bResponsive": true,
                                "paging": true,
                                "order": [],
                                "orderable": false
                            })
                        }
                        else if (jsonResult == null) {

                        }


                        else
                            logger.logError('Some error occured while fetching Surveys. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetMappingList() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

        }

        function InitiateLevelTree() {
            try {
                

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {

                    url: "/api/RiskRatingConfiguration/GetAllSurveyAreasForRR",
                    type: "GET",
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in SurveyResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                if (jsonResult != null) {
                    if (jsonResult.AreaLevelsData["#"] == undefined) {
                        $('#SurveysDiv').hide();
                        $('#FilterAreaAccordion').hide();
                        $('#ProfileRR').hide();
                        $('#tblFactorMap').hide();
                        $('#error').show();

                    }
                    else {
                        $('#error').hide();
                        $('#SurveysDiv').show();
                        $('#FilterAreaAccordion').show();
                        $('#ProfileRR').show();
                        $('#tblFactorMap').show();
                        //implement js tree logic here
                        RRSurveyConfigVM.AreaLeveljstree(jsonResult.AreaLevelsData);

                        var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                            return new jsTreeModel(result);
                        });
                        $('#jsTreeAreaLevel').treeview({
                            data: MappedJsTreeList,
                            onNodeSelected: nodeClickEvent
                        });

                        var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                        RRSurveyConfigVM.hasChildNodes(hasChildNodes);

                        //for initial load expand for treeview
                        $("#jsTreeAreaLevel ul:first li:first").trigger("click");
                        $("loadingImgOrCalc").hide();
                        $("loadingMainImgDivTh").hide();
                        $("loadingImgMainTh").hide();
                    }
                }
                else  {
                    $('#error').show();
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in InitiateLevelTree() method in AMLThresholds.js';
                    logger.logMessage(msg);
                }
            }

            function filterJsTree(TreeStructure) {

                return TreeStructure.filter(
                    function (item) {
                        if (item.nodes != undefined && item.nodes.length > 0) {
                            item.nodes = filterJsTree(item.nodes);
                        }

                        if (item.showLevel == 1)
                            return true;
                        else
                            return false;

                    }
                );
            }


            function nodeClickEvent(event, node) {
                // Your logic goes here

                    //select node explicitly in case of recursive calling activity.
                    $('#jsTreeAreaLevel').treeview('selectNode', [node.nodeId, { silent: true }]);

                if (node.dead_node == 0) {
                    RRSurveyConfigVM.CurrentSurveyId(parseInt(node.ActualParentArealId));
                    RRSurveyConfigVM.CurrentSurveyName(node.text);
                }
                RRSurveyConfigVM.CurrentSurveyId(parseInt(node.ActualParentArealId));
                RRSurveyConfigVM.CurrentRiskFactorId(parseInt(node.ActualAreaID));
              
                if (node.RA_Type() == "P") {
                    RRSurveyConfigVM.ApplyBlueprintFlag(node.IsBlueprintApplied());
                    if (RRSurveyConfigVM.ApplyBlueprintFlag() == 0) {
                        $('#import' + RRSurveyConfigVM.CurrentSurveyId()).attr('disabled', false);
                        $('#applyblueprint' + RRSurveyConfigVM.CurrentSurveyId()).attr('disabled', false);
                        $('#advancedblueprint' + RRSurveyConfigVM.CurrentSurveyId()).attr('disabled', false);
                       // $('#import' + RRSurveyConfigVM.CurrentSurveyId()).removeClass().addClass('secondary-btn');
                        $('#applyblueprint' + RRSurveyConfigVM.CurrentSurveyId()).removeClass().addClass('secondary-btn');
                        $('#advancedblueprint' + RRSurveyConfigVM.CurrentSurveyId()).removeClass().addClass('secondary-btn');
                    }
                    else if (RRSurveyConfigVM.ApplyBlueprintFlag() == 1) {
                        $('#import' + RRSurveyConfigVM.CurrentSurveyId()).attr('disabled', true);
                        $('#applyblueprint' + RRSurveyConfigVM.CurrentSurveyId()).attr('disabled', true);
                        $('#advancedblueprint' + RRSurveyConfigVM.CurrentSurveyId()).attr('disabled', true);
                      //  $('#import' + RRSurveyConfigVM.CurrentSurveyId()).removeClass().addClass('rr-border');
                        $('#applyblueprint' + RRSurveyConfigVM.CurrentSurveyId()).removeClass().addClass('rr-border');
                        $('#advancedblueprint' + RRSurveyConfigVM.CurrentSurveyId()).removeClass().addClass('rr-border');
                    
                    }

                    GetRRSurveys().then(function () {
                        GetUsersListForAllSurveys();
                    })
                 
                    $('#SurveysDiv').show();
                    $('#ProfileRR').show();
                    $('#FactorMapping').hide();
                }
                    
                else if (node.RA_Type() == "F"){
                    $('#SurveysDiv').hide();
                    $('#ProfileRR').hide();
                    $('#FactorMapping').show();
                    GetMappingList();
                    
                }
                    $('#loadingMainImgDivFactors').show();
              
            }
            

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in SurveyResponsePage.js';
                    logger.logMessage(msg);
                }
            };
        }
        function GetallSurveys() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingConfiguration/GetAllSurveys",
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null && jsonResult.length > 0) {
                            var MappedSurveyList = $.map(jsonResult, function (result) {
                                return new SurveyListModel(result);
                            });

                            var Surveytableobject = $('#SurveyTypeTable').DataTable();
                            Surveytableobject.destroy();
                            $('#SurveyTypeTable tbody tr').remove();
                            RRSurveyConfigVM.SurveyCreateModel(MappedSurveyList);
                            $('#SurveyTypeTable').DataTable({
                                "bResponsive": true,
                                "stateSave": true,
                                "paging": true,
                                "order": [],
                                "orderable": false
                            })
                        }
                        else if (jsonResult != null && jsonResult.length == 0) {
                            var Surveytableobject = $('#SurveyTypeTable').DataTable();
                            Surveytableobject.destroy();
                            $('#SurveyTypeTable tbody tr').remove();
                            $('#SurveyTypeTable').DataTable({
                                "stateSave": true,
                                "targets": 'no-sort',
                                "bResponsive": true,
                                "paging": true,
                                "order": [],
                                "orderable": false
                            })
                        }
                        else if (jsonResult == null) {

                        }


                        else
                            logger.logError('Some error occured while fetching Surveys. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the type assessments. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }

        }

        function surveyMapping(data, event) {
            try {
                RRSurveyConfigVM.SelectedSurveyName(data.RRSurveyName());
                RRSurveyConfigVM.SelectedSurveyTableId(data.RRSurveyTableUId());
                RRSurveyConfigVM.SelectedSurveyId(data.RRSurveyId());
                RRSurveyConfigVM.IsCurrentSurveyLaunched(data.IsLaunched());
                $('#valErrorMapping').hide();
                $('#NoRRISelected').hide();
                $('#saveMappingBtn').hide();
                //$('#selectAllDiv').hide();
                if (RRSurveyConfigVM.SelectedLevelType() === "RRI") {
                    $('#RRIDropdownDiv').hide();
                    $('#RRITabsDiv').hide();
                    $('#QuestionsDiv').show();
                    if (data.IsMappedFlag() !== 1) {
                        GetRRIQuestionDetails(data.RRSurveyTableUId()).then(function () {
                            createQuestionsTable(data.RRSurveyTableUId());
                        });
                    }
                    else if (data.IsMappedFlag() === 1) {
                        GetMappedSurveyQuestions().then(function () {
                            createQuestionsTable(data.RRSurveyTableUId());
                        });
                        $('#saveMappingBtn').show();
                    }
                    RRSurveyConfigVM.ClickedRRItem(data.RRSurveyTableUId());
                }
                else {
                    $('#RRIDropdownDiv').show();
                    $('#RRITabsDiv').hide();
                    if (data.IsMappedFlag() !== 1) {
                        RRSurveyConfigVM.SelectedRRItems([]);
                        $('#QuestionsDiv').hide();
                        $('#RRIDropdown').multiselect();
                        $('#RRIDropdown').multiselect('refresh');
                    }
                    if (data.IsMappedFlag() === 1) {
                        GetMappedSurveyQuestions().then(function () {
                            $('#saveMappingBtn').show();
                            var SelectedRRIArray = [];
                            var RRIArray = [];
                            for (var i = 0; i < RRSurveyConfigVM.RRItemsList().length; i++) {
                                for (var j = 0; j < RRSurveyConfigVM.ItemQuestionsList().length; j++) {
                                    if (parseInt(RRSurveyConfigVM.ItemQuestionsList()[j].RRItemId()) === RRSurveyConfigVM.RRItemsList()[i].RRItemId) {
                                        RRIArray.push(RRSurveyConfigVM.RRItemsList()[i]);
                                        SelectedRRIArray.push(RRSurveyConfigVM.RRItemsList()[i].RRItemId);
                                    }
                                }
                            }
                            RRSurveyConfigVM.RRItemsTabList(RRIArray);
                            RRSurveyConfigVM.SelectedRRItems(SelectedRRIArray);
                            $('#RRIDropdown').multiselect();
                            $('#RRIDropdown').multiselect('refresh');

                            $('#RRITabsDiv').show();
                            $('#QuestionsDiv').hide();

                            $('#RRITabsDiv').tabs();
                            $('#RRITabsDiv').tabs('refresh');
                            $('#RRITabsDiv').tabs({ active: 0 });
                            $($('#RRITabsUL li').get(0)).trigger('click');
                            scrollableTabs();
                        });
                    }
                }
                $('#ModalSurveyMapping').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: surveyMapping() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function SaveSurvey(data, event) {
            try {

                if (data.editableSurvey().RRSurveyName().length == 0 || data.editableSurvey().RRSurveyName() == "") {
                    $('#valErrorSurvey').text("Survey Short Name can not be empty");
                    $('#valErrorSurvey').show();
                    return false;
                }
                else if (data.editableSurvey().RRSurveySecondaryName().length == 0 || data.editableSurvey().RRSurveySecondaryName() == "") {
                    $('#valErrorSurvey').text("Survey Name can not be empty");
                    $('#valErrorSurvey').show();
                    return false;
                }
                else if (data.SelectedCopyAreas() == "" || data.SelectedCopyAreas().length == 0) {
                    $('#valErrorSurvey').text("Please select atleast one factor");
                    $('#valErrorSurvey').show();
                    return false;
                }
                else if (RRSurveyConfigVM.SelectedAssessmentType().length == 0) {
                    return false;
                }
                else {
                    AddSurvey(data)
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }


        function AddSurvey(data) {
            try {
                var selectedassessmetId = "";
                for (var i = 0; i < data.SelectedAssessmentType().length; i++) {
                    if (i == 0)
                        selectedassessmetId += selectedassessmetId + data.SelectedAssessmentType()[i];
                    else
                        selectedassessmetId += "," + data.SelectedAssessmentType()[i];
                }
                var selectedfactorId = "";
                for (var i = 0; i < data.SelectedCopyAreas().length; i++) {
                    if (i == 0)
                        selectedfactorId += selectedfactorId + data.SelectedCopyAreas()[i];
                    else
                        selectedfactorId += "," + data.SelectedCopyAreas()[i];
                }
    
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/AddSurvey",
                    type: "POST",
                    data: { RRFactors: selectedfactorId, RRSurveyName: data.editableSurvey().RRSurveyName(), RRSurveySecondaryName: data.editableSurvey().RRSurveySecondaryName(), RRSurveyApplicableIDs: selectedassessmetId, RREndDate: $('#RREndDate').val()},
                    headers: headers,
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult > 0) {
                            $('#frmSurvey').modal('hide');
                            
                            logger.logSuccess('Survey has been added successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                            //RRSurveyConfigVM.AssessmentTypeListDupAsPerSurveytype([]);
                            GetallSurveys();
                            InitiateLevelTree();
                            //var newAssessment = new SurveyListModel({ SurveyId: 999, SurveyName: "", SurveySecondName: "", surveyType: "", Applicability: "" });
                            //RRSurveyConfigVM.SurveyCreateModel(newAssessment);
                            //RRSurveyConfigVM.editableSurvey(newAssessment);
                            //$('#SurveyAssessmentApplicability').multiselect();
                            //$("#" + RRSurveyConfigVM.SelectedSurveyType()).trigger('click');
                            $('#valErrorSurvey').hide();
                        }

                        else {
                            logger.logError('Some error occured while adding the Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while adding Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
}


        function UpdateSurvey(data, event) {
            try {
                if (data.editableSurvey().RRSurveyName().length == 0 || data.editableSurvey().RRSurveyName() == "") {
                    return false;
                }
                else if (data.editableSurvey().RRSurveySecondaryName().length == 0 || data.editableSurvey().RRSurveySecondaryName() == "") {
                    return false;
                }
                else {
                    EditSurveyDetails(data);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UpdateSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }



        function EditSurveyDetails(data) {
            try {
                var selectedassessmetId = "";
                for (var i = 0; i < RRSurveyConfigVM.SelectedAssessmentType().length; i++) {
                    if (i == 0)
                        selectedassessmetId += selectedassessmetId + RRSurveyConfigVM.SelectedAssessmentType()[i];
                    else
                        selectedassessmetId += "|" + RRSurveyConfigVM.SelectedAssessmentType()[i];
                }
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingConfiguration/EditSurvey",
                    type: "POST",
                    data: { RRSurveyId: data.editableSurvey().RRSurveyId(), RRSurveyName: data.editableSurvey().RRSurveyName(), RRSurveySecondaryName: data.editableSurvey().RRSurveySecondaryName, RREndDate: $('#RREndDate').val() },
                    headers: headers,
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Survey has been edited successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                           
                            var newAssessment = new SurveyListModel({ RRSurveyId: 999, RRSurveyName: "", RRSurveySecondaryName: "", RRFactorsNames: "", RRSurveyApplicableNames: "" });
                            RRSurveyConfigVM.SelectedAssessmentType([]);
                            RRSurveyConfigVM.editableSurvey(newAssessment);
                            RRSurveyConfigVM.EditFactorVisible(false);
                            RRSurveyConfigVM.SelectedCopyAreas([]);
                            $('#RAApplicability').multiselect();
                            $('#copyareasMultiselect').multiselect();
                            $('#LoadingImgAddSrPopup').hide();
                            $('#DivForScroll').show();
                            RRSurveyConfigVM.popUpTitle("Add new survey component");
                            InitiateLevelTree();
                            GetallSurveys();
                        }

                        else {
                            logger.logError('Some error occured while editing the Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (jsonResult, error) {
                        logger.logError('An error has occurred while editing Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditSurveyDetails() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SurveyMappingPopup() {
            try {
                app.showMessage(" By clicking the <b> Confirm </b> button, I acknowledge the following: </b> \n <br> 1. I have reviewed the survey mapping. \n <br> 2. The surveys would be created and survey mapping cannot be changed. If you do not wish to proceed, please click on <b> Deny</b>. \n", "Acknowledgement", ["Confirm", "Deny"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                    .then(function (option) {
                        if (option == 'Confirm') {
                            ApplyBlueprintRR();
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }


    function ApplyBlueprintRR() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/RiskRatingConfiguration/ApplyRRBlueprint?ProfileId=" + RRSurveyConfigVM.CurrentRiskFactorId(),
                type: "POST",
                headers: headers
        })
            .success(function (jsonResult, error) {
                if (jsonResult > 0) {
                 
                    logger.logSuccess('Blueprint applied successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                    InitiateLevelTree();
                   
                }

                else {
                    logger.logError('Some error occured while adding the Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                }

            })
            .fail(function (jsonResult, error) {
                logger.logError('An error has occurred while adding Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
            });
    }
    catch (e) {
        var msg = 'Exception: ' + e + ' | Source: SaveSurvey() method in ConfigureSurvey.js';
        logger.logMessage(msg);
    }
}


        function EditSurvey(data, event) {
            try {
                var newSurvey = new SurveyListModel({ RRSurveyId: data.RRSurveyId(), RRSurveyName: data.RRSurveyName(), RRSurveySecondaryName: data.RRSurveySecondaryName(), RRFactors: data.RRFactors(), RRApplicability: data.RRApplicability(), RREndDate:"" });
             //   var newAssessment = new SurveyListModel({ RRSurveyId: 999, RRSurveyName: "", RRSurveySecondaryName: "", RRFactorsNames: "", RRSurveyApplicableNames: "" });
                newSurvey.Editing = true;
                var Assessment = data.RRApplicabilityNames();
                var factorNames = data.RRFactorsNames();
                RRSurveyConfigVM.EditFactorVisible(true);
                RRSurveyConfigVM.editableSurvey(newSurvey);
                RRSurveyConfigVM.popUpTitle("Edit Survey Details");
                RRSurveyConfigVM.SelectedAssessmentType([]);
                $('#EditFactorAssessment').empty();
                document.getElementById('EditFactorAssessment').innerHTML = Assessment;
                $('#EditFactorNames').empty();
                document.getElementById('EditFactorNames').innerHTML = factorNames;
                $('#RREndDate').datepicker();
                $('#SurveyApplicabilityDropdown').hide();
                RRSurveyConfigVM.addPopUpCssSurvey(false);
                RRSurveyConfigVM.DisableSurveyDropdown(true);
                RRSurveyConfigVM.DisableApplicabilityDropdown(true);
                $('#frmSurveyPopup').modal('show');

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }
        function saveSurveyMapping(data, event) {
            try {
                var splitLevel = "";
                if (Array.isArray(RRSurveyConfigVM.SelectedLevelOption()))
                    splitLevel = RRSurveyConfigVM.SelectedLevelOption()[0];
                else
                    splitLevel = RRSurveyConfigVM.SelectedLevelOption();

                var count = 0;
                var mappingsList = [];
                for (var i = 0; i < data.ItemQuestionsList().length; i++) {
                    for (var j = 0; j < data.ItemQuestionsList()[i].QuestionsList().length; j++) {
                        mappingsList.push(new RRQuestionsModel({
                            RRItemId_Ques: data.ItemQuestionsList()[i].QuestionsList()[j].RRItemId_Ques(),
                            QuestionId: data.ItemQuestionsList()[i].QuestionsList()[j].QuestionId(),
                            QuestionName: data.ItemQuestionsList()[i].QuestionsList()[j].QuestionName(),
                            IsChecked: data.ItemQuestionsList()[i].QuestionsList()[j].IsChecked()
                        }));
                        if (data.ItemQuestionsList()[i].QuestionsList()[j].IsChecked() === true)
                            count++;
                    }
                }
                if (count === 0) {
                    $('#valErrorMapping').show();
                    $('#valErrorMapping').empty();
                    document.getElementById('valErrorMapping').innerHTML = "Please select atleast one Question";
                    return false;
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SetSurveyMapping?SelectedLevelOption=" + splitLevel +
                        "&SelectedMRRAId=" + parseInt(RRSurveyConfigVM.SelectedMRRAreaId()) +
                        "&SelectedSurveys=" + RRSurveyConfigVM.SelectedSurveyTableId() + "&SelectedSurveyProfileId=" + RRSurveyConfigVM.SelectedSurveyProfileId(),
                    type: "POST",
                    headers: headers,
                    data: { SurveysList: data.SurveysList(), MappingsList: mappingsList }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult === 1) {
                            logger.logSuccess('Successfully saved Questionnaire Mappings.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                            $('#ModalSurveyMapping').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetRRSurveyLevels();
                        }
                        else {
                            logger.logError('An error has occurred while saving the Mappings.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while saving the Mappings. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: saveSurveyMapping() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Users-Assignement

        function GetUsersListForAllSurveys() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetUsersListForAllSurveys?SelectedSurveyId=" + RRSurveyConfigVM.CurrentSurveyId(), 
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                var mappedUserList = $.map(jsonResult, function (result) {
                                    return new SurveyUserModel(result);
                                });
                                RRSurveyConfigVM.UsersList(mappedUserList);
                            }
                        }
                        else {
                            logger.logError('An error has occured while fetching the Users List for Surveys. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Users List for Surveys. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetUsersListForAllSurveys() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function assignUsers(data, event) {
            try {
                RRSurveyConfigVM.SelectedSurveyId(data.RRSurveyId());
                RRSurveyConfigVM.SurveyUsersList([]);

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetUsersWorkFlowList?SelectedSurveyId=" + RRSurveyConfigVM.CurrentSurveyId(),
                    type: "GET",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0) {
                                RRSurveyConfigVM.CurrentRoleType(jsonResult[0].RoleShortName);
                                RRSurveyConfigVM.WorkFlowList(jsonResult);
                                $('#UserAssignment').modal('show');

                                Obj = $('#tblSurveyUser').DataTable();
                                Obj.destroy();
                                $('#tblSurveyUser tbody tr').remove();

                                var UserList = ko.toJS(RRSurveyConfigVM.UsersList());

                                var UList = $.map(UserList, function (result) {
                                    if (parseInt(result.SurveyId) === parseInt(RRSurveyConfigVM.SelectedSurveyId()) && result.IsAssigned) {
                                        return new SurveyUserModel(result);
                                    }
                                });

                                RRSurveyConfigVM.SurveyUsersList(UList);

                                $('#tblSurveyUser').DataTable({
                                    "order": [],
                                    "aaSorting": [],
                                    "bResponsive": true,
                                    "aoColumnDefs": [
                                        {
                                            "aTargets": [0],
                                            "bSortable": false
                                        }]
                                });
                                $('#tblSurveyUser').DataTable().draw(false);
                            }
                            else {
                                logger.logError('An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                        }
                        else {
                            logger.logError('An error has occured while fetching the Users WorkFlow List Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }

                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the Users WorkFlow List Items. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });


            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: assignUsers() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function RoleNameClick(data, event) {
            try {
                RRSurveyConfigVM.CurrentRoleType(data.RoleShortName);
                RRSurveyConfigVM.SurveyUsersList([]);
                UsertableObj = $('#tblSurveyUser').DataTable();
                UsertableObj.destroy();
                $('#tblSurveyUser tbody tr').remove();

                var UList = [];
                var UserList = ko.toJS(RRSurveyConfigVM.UsersList());

                if (RRSurveyConfigVM.CurrentRoleType() !== "ASSIGNED_USER_LIST") {
                    UList = $.map(UserList, function (result) {
                        if (parseInt(result.SurveyId) === parseInt(RRSurveyConfigVM.SelectedSurveyId()) && result.RoleType === RRSurveyConfigVM.CurrentRoleType()) {
                            return new SurveyUserModel(result);
                        }
                    });
                }
                else {
                    UList = $.map(UserList, function (result) {
                        if (parseInt(result.SurveyId) === parseInt(RRSurveyConfigVM.SelectedSurveyId()) && result.IsAssigned) {
                            return new SurveyUserModel(result);
                        }
                    });
                }

                RRSurveyConfigVM.SurveyUsersList(UList);

                $('#tblSurveyUser').DataTable({
                    "order": [],
                    "aaSorting": [],
                    "bResponsive": true,
                    "aoColumnDefs": [
                        {
                            "aTargets": [0],
                            "bSortable": false
                        }]
                });
                $('#tblSurveyUser').DataTable().draw(false);
                $('#selectallUsers').prop('checked', false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RoleNameClick() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SelectAllUsers(data, event) {
            try {
                for (var i = 0; i < RRSurveyConfigVM.SurveyUsersList().length; i++) {
                    RRSurveyConfigVM.SurveyUsersList()[i].IsAssigned(event.currentTarget.checked);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SelectAllUsers() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SaveUserMapping(data, event) {
            try {
                $('#ValErrorSurvey').hide();
                var count = 0;
                for (var i = 0; i < RRSurveyConfigVM.SurveyUsersList().length; i++) {
                    if (RRSurveyConfigVM.SurveyUsersList()[i].IsAssigned()) {
                        count++;
                    }
                }
                if (count === 0) {
                    $('#ValErrorSurvey').show();
                    document.getElementById('ValErrorSurvey').innerHTML = "Please select atleast one User";
                    return false;
                }

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SetSurveyUserMapping",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify($.map(RRSurveyConfigVM.SurveyUsersList(), function (result) {
                        return {
                            SurveyId: result.SurveyId(), UserId: result.UserId(), RoleId: result.RoleId(), RoleType: result.RoleType(),
                            IsAssigned: result.IsAssigned(), UserName: result.UserName(), UserRoleName: result.UserRoleName()
                        };
                    }))
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult === 1) {
                            logger.logSuccess('Survey User Mappings have been saved successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                            $('#UserAssignment').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetRRSurveys().then(function () {
                                GetUsersListForAllSurveys();
                            });
                            
                        }
                        else {
                            logger.logError('An error has occurred while saving the Survey User Mappings.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while saving the Survey User Mappings. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveUserMapping() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region SurveyLaunch

        function SurveyLaunchPopUp(data, event) {
            try {
                app.showMessage('Are you sure you want to Launch the Survey?', 'Confirm Survey Launch', [' Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-chevron-right text-default' })
                    .then(function (option) {
                        if (option === ' Confirm') {
                            SurveyLaunch(data.RRSurveyId());
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyLaunchPopUp() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function LaunchSurvey() {
            try {

                var BuIdList = ConstructLaunchSurveyJson();
                if (BuIdList.length == 0) {
                    logger.logError('The selected surveys have already been launched or the questionnaire hasn\'t been assigned.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                }
                else {
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    return $.ajax({
                        url: "/api/RiskRatingDashboard/SurveyLaunch?SurveyIds=" + BuIdList.toString(),
                        headers: headers,
                        type: "POST"
                       
                      
                    })
                        .success(function (jsonResult, success) {
                            if (jsonResult == undefined || jsonResult == 0) {
                                logger.logError('An error occurred. Please contact the Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                            }
                            else if (jsonResult > 0) {
                                $('#frmlaunchPopup').modal('hide');
                                logger.logSuccess('Selected Survey launch has been initiated.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                                GetRRSurveys().then(function () {
                                    GetUsersListForAllSurveys();
                                });

                            }
                        })
                        .fail(function (jsonResult, error) {

                        })
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LaunchSurvey() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function ConstructLaunchSurveyJson() {
            try {
                var x = [];
                for (var i = 0; i < RRSurveyConfigVM.SelectedBuIdList().length; i++) {
                    for (var j = 0; j < RRSurveyConfigVM.SurveysList().length; j++) {
                        if (RRSurveyConfigVM.SelectedBuIdList()[i] == RRSurveyConfigVM.SurveysList()[j].RRSurveyId()) {
                            if (RRSurveyConfigVM.SurveysList()[j].IsLaunched() == 0) {
                                x.push(RRSurveyConfigVM.SurveysList()[j].RRSurveyId());
                            }
                        }
                    }


                }
                return x;

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConstructLaunchSurveyJson() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }

        }

        function SurveyLaunch(selectedIds) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SurveyLaunch?SurveyIds=" + selectedIds.toString(),
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult === 1) {
                            logger.logSuccess('Survey has been launched saved successfully.', 'Success', system.getModuleId(RRSurveyConfigVM), true);
                            GetRRSurveys().then(function () {
                                GetUsersListForAllSurveys();
                            });
                            
                        }
                        else {
                            logger.logError('An error has occurred while launching the Survey.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while launching the Survey. Please contact your Administrator.', 'Error', system.getModuleId(RRSurveyConfigVM), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyLaunch() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Model Definitions

        function jsTreeModel(item) {
            var self = this;
            self.ActualAreaID = item.AreaID.toString();
            self.id = item.AreaLevelIdRR.toString();
            self.text = item.AreaLevelName;
            //if (RRSurveyConfigVM.AreaLeveljstree()[self.id].length > 0) {
            //    self.nodes = $.map(RRSurveyConfigVM.AreaLeveljstree()[self.id], function (result) {
            //        return new jsTreeModel(result);
            //    });
            //}
            if (RRSurveyConfigVM.AreaLeveljstree()[self.id].length > 0) {
                self.nodes = $.map(RRSurveyConfigVM.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.ParentAreaLevelId = item.ParentAreaLevelId;
            self.ActualParentArealId = item.ParentAreaId;
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
            self.IsBlueprintApplied = ko.observable(item.IsBlueprintApplied);
            
        }
        function LaunchBusinessUnitModel(item) {
            try {
                var self = this;
                self.RRSurveyId = item.RRSurveyId();
                self.RRSurveyName = $('<div/>').html(item.RRSurveyName()).text();
               
                if (item.IsLaunched() ==  1) {
                    self.ColorCode = "#012169"
                    self.Status = "Launched";
                }
                else if (item.IsLaunched() == 0) {
                    self.ColorCode = "#012169"
                    self.Status = "Can be Launched";
                }
                //else {
                //    self.Status = "Cannot be  Launched";
                //    self.ColorCode = "#97999B";
                //}

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LaunchBusinessUnitModel() method in ConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function RRSurveyModel(item) {
            try {
                var self = this;
                self.RRSurveyId = ko.observable(item.RRSurveyId);
                self.RRSurveyProfileId = ko.observable(item.RRSurveyProfileId);
                self.RRSurveyName = ko.observable(item.RRSurveyName);
                self.RRSurveyDescription = ko.observable(item.RRSurveyDescription);
                self.RRSurveyTableKey = ko.observable(item.RRSurveyTableKey);
                self.RRSurveyTableUId = ko.observable(item.RRSurveyTableUId);
                self.isChecked = ko.observable(false);
                self.IsLaunched = ko.observable(item.IsLaunched);
                self.LaunchStatus = ko.observable(item.LaunchStatus);
                if (item.IsLaunched > 0) {
                    self.ColorCode = ko.observable("#012169")
                    self.Status = ko.observable("Can be Launched");
                }
                else {
                    self.Status = ko.observable("Cannot be  Launched");
                    self.ColorCode = ko.observable("#97999B");
                }
                self.AssignedUsersList = ko.observable(item.AssignedUsersList.replace(/} /g, '<br>'));
                self.IsMappedFlag = ko.observable(item.IsMappedFlag);

                if (item.IsLaunched > 0) {
                    self.MainListColourCode = ko.observable("#012169");
                }
                else {
                    self.MainListColourCode = ko.observable("#97999B");
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRSurveyModel() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function AssessmentListModel(item) {
            try {
                var self = this;
                self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
                self.AssessmentName = ko.observable(item.AssessmentName);
                self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
                self.Description = ko.observable($('<div/>').html(item.Description).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in RiskRatingFactorSetup.js';
                logger.logMessage(msg);
            }
        }

      
        function RRItemQuestionsModel(item) {
            try {
                var self = this;
                self.RRItemId = ko.observable(item.RRItemId);
                self.RRItemName = ko.observable(item.RRItemName);
                var mappedQuestionsList = $.map(item.QuestionsList, function (result) {
                    return new RRQuestionsModel(result);
                });
                self.QuestionsList = ko.observable(mappedQuestionsList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRItemQuestionsModel() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function RRQuestionsModel(item) {
            try {
                var self = this;
                self.RRItemId_Ques = ko.observable(item.RRItemId_Ques);
                self.QuestionId = ko.observable(item.QuestionId);
                self.QuestionName = ko.observable(item.QuestionName);
                self.UniqueItemQuesId = ko.observable(item.RRItemId_Ques + '_' + item.QuestionId); //ItemId_QuestionId
                self.IsChecked = ko.observable(item.IsChecked);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRQuestionsModel() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function SurveyUserModel(item) {
            try {
                var self = this;
                self.SurveyId = ko.observable(item.SurveyId);
                self.UserName = ko.observable(item.UserName);
                self.UserId = ko.observable(item.UserId);
                self.RoleId = ko.observable(item.RoleId);
                self.UserRoleName = ko.observable(item.UserRoleName);
                self.Role = ko.observable(item.UserRoleName);
                self.RoleType = ko.observable(item.RoleType);
                self.IsAssigned = ko.observable(item.IsAssigned);
                self.IsChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyUserModel() method in RRConfigureSurvey.js';
                logger.logMessage(msg);
            }
        }

        function RRAreaModel(item) {
            try {
                var self = this;
                self.MRRAId = ko.observable(item.MRRAId);
                self.MRRAName = ko.observable(item.MRRAName);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RRItemModel() method in RiskRatingConfiguration.js';
                logger.logMessage(msg);
            }
        }
        //#endregion

    });
